import React, { useState } from 'react';
import Modal from './Modal';

interface OrderApiIdsCellProps {
  orderId: number;
  value: string | null | undefined;
  onCopy: (value: string) => void;
}

const OrderApiIdsCell: React.FC<OrderApiIdsCellProps> = ({ orderId, value, onCopy }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ids = (value || '').split(',').map(id => id.trim()).filter(Boolean);

  return (
    <td style={{ padding: '12px', fontSize: '14px', width: '160px', maxWidth: '160px', boxSizing: 'border-box' }} onClick={event => event.stopPropagation()}>
      {ids.length === 0 ? <span style={{ color: '#64748b' }}>-</span> : ids.length === 1 ? (
        <button
          type="button"
          onClick={() => onCopy(ids[0])}
          title={`Sao chép ID API: ${ids[0]}`}
          style={{ border: 0, padding: 0, background: 'none', color: '#6366f1', cursor: 'pointer', font: 'inherit', fontWeight: 500, display: 'block', width: '100%', maxWidth: '136px', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {ids[0]}
        </button>
      ) : (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label={`Xem ${ids.length} mã ID API của đơn #${orderId}`}
          aria-haspopup="dialog"
          aria-expanded={isOpen}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid #c7d2fe', borderRadius: '6px', padding: '6px 10px', background: '#eef2ff', color: '#4338ca', cursor: 'pointer', font: 'inherit', whiteSpace: 'nowrap' }}
        >
          <span style={{ fontWeight: 700 }}>{ids.length} mã</span>
          <span style={{ fontSize: '12px' }}>Xem ▸</span>
        </button>
      )}

      {isOpen && (
        <Modal isOpen onClose={() => setIsOpen(false)} title={`ID API · Đơn #${orderId}`}>
          <div role="dialog" aria-label={`Danh sách ID API của đơn #${orderId}`}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <span style={{ color: '#475569' }}>{ids.length} mã đơn hàng</span>
              <button type="button" className="btn-secondary" onClick={() => onCopy(ids.join(','))}>Sao chép tất cả</button>
            </div>
            <ol style={{ margin: 0, paddingLeft: '24px', maxHeight: '50vh', overflowY: 'auto' }}>
              {ids.map((id, index) => (
                <li key={`${index}-${id}`} style={{ color: '#64748b', padding: '6px 0' }}>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', paddingRight: '8px' }}>
                    <code style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere', color: '#1e293b' }}>{id}</code>
                    <button type="button" className="btn-secondary" style={{ flexShrink: 0, padding: '4px 8px' }} aria-label={`Sao chép mã ${id}`} onClick={() => onCopy(id)}>Sao chép</button>
                  </div>
                </li>
              ))}
            </ol>
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
              <button type="button" className="btn-secondary" onClick={() => setIsOpen(false)}>Đóng</button>
            </div>
          </div>
        </Modal>
      )}
    </td>
  );
};

export default OrderApiIdsCell;
